import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import { GoTerminal } from "react-icons/go";
import { FiLogOut } from "react-icons/fi";
import * as routes from "../constants/routes";

import "./header.css";

const Header2 = ({ setSelectedCourse, handleSignOut }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <div className="header-container" style={{ width: "100%" }}>
      <div className="logo-container">
        <Link to={routes.HOME}>
          <GoTerminal className="p-0 logo-style" size={30} />
        </Link>
        <h4 className="text-start text-light">TLZ</h4>
      </div>
      <div className="menu-options-container">
        <div className="options-container">
          <p className="menu-items">Courses</p>
        </div>
        <div className="login-signup-container">
          <Button
            color="link"
            className="menu-items"
            style={{
              color: "#fff"
            }}
          >
            Login
          </Button>
          <Button
            style={{
              backgroundColor: "#c8e6c9",
              color: "#000"
            }}
          >
            Signup
          </Button>
          <Button color="link" onClick={handleSignOut}>
            <FiLogOut className="p-0 logo-style" size={30} />
          </Button>
        </div>
      </div>
    </div>
  );
};

// Header2.propTypes = {
//   // siteTitle: PropTypes.string,
//   setSelectedCourse: PropTypes.func,
//   handleSignOut: PropTypes.func
// };

export default Header2;
